import React from 'react';
import { Sparkles } from 'lucide-react';

interface SuggestionBarProps {
    suggestions: string[];
    onSelect: (suggestion: string) => void;
    visible: boolean;
}

export const SuggestionBar: React.FC<SuggestionBarProps> = ({ suggestions, onSelect, visible }) => {
    if (!visible || suggestions.length === 0) return null;

    return (
        <div className="px-6 flex flex-wrap justify-center gap-2 z-20 animate-in fade-in slide-in-from-bottom-4 duration-500">
            {suggestions.map((text, index) => (
                <button
                    key={index}
                    onClick={() => onSelect(text)}
                    className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-400/10 backdrop-blur-md border border-blue-400/30 rounded-full text-white/90 text-[11px] font-medium shadow-sm active:scale-95 transition-all hover:bg-blue-400/20 hover:border-blue-400/50"
                >
                    <Sparkles className="w-3 h-3 text-blue-300" />
                    {text}
                </button>
            ))}
        </div>
    );
};
